import { Injectable } from '@angular/core';
import { APP_CONST } from '../../app.const';
import { RequestService } from '../../libraries/http/request.service';

@Injectable()
export class DashboardRestService {
  dashboardRequest = this._request.new(`${APP_CONST.API_MASTER}/admin/dashboard`);
  trxRequest = this._request.new(`${APP_CONST.API_MASTER}/admin/transaction-history`);
  invoiceRequest = this._request.new(`${APP_CONST.API_MASTER}/admin/membership-invoice`);

  constructor(private _request: RequestService) {}

  getAllSummary() {
    return this.dashboardRequest.get<any>(`/summary`);
  }

  getTransactionHistory(queryParams) {
    return this.trxRequest.get<any>(``, { params: queryParams });
  }

  getWithdrawList(queryParams) {
    return this.trxRequest.get<any>(`/withdraw-list`, { params: queryParams });
  }

  getTransactionHistorySummary(queryParams) {
    return this.trxRequest.get<any>(`/summary`, { params: queryParams });
  }

  getBalance() {
    return this.trxRequest.get<any>('/balance');
  }

  getSnapToken(orderData) {
    return this.trxRequest.post('/top-up', orderData);
  }

  getSnapTokenMembership(orderData) {
    return this.trxRequest.post('/membership-payment', orderData);
  }

  getDealerByUser(userId: string) {
    const adminDealer = `${APP_CONST.API_MASTER}/admin/dealers`;
    const adminRequest = this._request.new(adminDealer);
    return adminRequest.get<any>(`/profile/${userId}`);
  }

  approveWithdraw(payload: any) {
    return this.trxRequest.patch<any>(`/withdraw/approve`, payload);
  }

  requestWithdraw(payload: any) {
    return this.trxRequest.post<any>(`/withdraw/request`, payload);
  }

  getMembershipInvoice() {
    return this.invoiceRequest.get<any>('');
  }

  getTransactionCategory() {
    return this.trxRequest.get<any>(`/transaction-category`);
  }

  retryTransaction(id: string) {
    return this.trxRequest.post<any>(`/retry/${id}`);
  }

  updateTransactionId(id: string, tid: string) {
    return this.trxRequest.patch<any>(`/transaction/${id}`, { tid });
  }
}
